/**
 * @method
 * @param {string} count count of reviews and ratings
 * @returns {string} message about ratings for title
 */
export const getRatingsMessage = (count) => {
  return count > 1 ? `${count} ratings` : count ? "1 rating" : "No ratings yet";
};
